import BrowserPersistence from "web/utils/system/storage/storage/browserPersistence";

import storageNames from "web/constants/storageNames";

import { IStoredToken } from "web/types/Token";

import { setStoredToken } from "./getTokenState";

const storage = new BrowserPersistence();

const persistToken = (tokenData: IStoredToken): void => {
  const { token, accessToken, idToken, ttl } = tokenData;

  storage.setItem(storageNames.token, null, token, ttl);
  storage.setItem(storageNames.tokenAccess, null, accessToken, ttl);
  storage.setItem(storageNames.idToken, null, idToken, ttl);

  window.dispatchEvent(
    new CustomEvent("tokenChange", { detail: { accessToken } })
  );

  setStoredToken(tokenData);
};

export default persistToken;
